import { isOnboardingEnabled } from '@/components/TopBar/onboardingAccess'
import { realEstatesRoute } from '@/router/routes/contants'

// Garde de route de l'onboarding « Démarrer ». FAIL-CLOSED : hors liste blanche, on
// renvoie vers « Mes biens », l'écran d'onboarding restant inaccessible.
//
// IMPORTANT (Vue Router 4) : NE PAS déclarer de paramètre `next`. Dès qu'une garde a une
// arité >= 3, Vue Router attend un next() explicite et IGNORE la valeur de retour ->
// navigation bloquée. En arité < 3, la valeur retournée (true, ou un chemin de
// redirection en string) est appliquée automatiquement.
export const onboardingBeforeEnter = async () => {
  if (!isOnboardingEnabled()) {
    return realEstatesRoute.path
  }

  return true
}
